exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table__footer .cell {\n  text-align: right;\n}\ntr.el-table__row.sous-total {\n  background-color: #F5F7FA!important;\n  font-weight:bold!important\n}\n", ""]);

// exports
